module.exports = __webpack_public_path__ + "img/touca_mascara.069c7363.svg";